module.exports = __webpack_public_path__ + "img/delete2.af1d07a2.svg";